var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1749657819548,
    className: "icon",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1492,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 1000C223.8461 1000 0 776.1694 0 500.0303 0 223.8306 223.8461 0 500 0c276.123 0 500 223.8306 500 500.0303C1000 776.1694 776.123 1000 500 1000M500 124.9487c-207.122 0-374.9991 167.9155-374.9991 375.0816 0 207.0426 167.8772 375.021 374.9991 375.021 207.0934 0 375.0003-167.9784 375.0003-375.021C875.0003 292.8642 707.0934 124.9487 500 124.9487M687.5013 562.5344H500c-34.5457 0-62.4993-28.0158-62.4993-62.5041V312.5203620064678c0-34.5488 27.9536-62.5041 62.4993-62.5041 34.5468 0 62.5004 27.9552 62.5004 62.5041v125.00700167239947h125.0008572976606c34.5457 0 62.4993 27.9541 62.4993 62.5029C750.0006 534.5185 722.047 562.5344 687.5013 562.5344",
    fill: "#00aaff",
    "p-id": 1493
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/次数.3176d441fa87b6569980dee0630755ed.svg";
export { ForwardRef as ReactComponent };